"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var warning_1 = __importDefault(require("warning"));
var useWarnContext = function (ctx) {
    var value = react_1.useContext(ctx);
    warning_1.default(value !== null, ctx.displayName + ": cannot find context. You probably forgot to wrap with the context.");
    return value;
};
exports.default = useWarnContext;
